// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BullhornDashboard_wrapper__td8f3"};